import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IAccordionProps {
  header: string | JSX.Element;
  icon?: JSX.Element | null;
  children: React.ReactNode;
  autoOpen?: boolean;
  alwaysOpen?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

export default function ControlledAccordions({ header, icon, children, autoOpen, alwaysOpen, onExpandedChange }: IAccordionProps) {
  const [expanded, setExpanded] = React.useState<boolean>(alwaysOpen ? true : autoOpen || false);

  React.useEffect(() => {
    if (onExpandedChange) {
      onExpandedChange(expanded);
    }
  }, [expanded]);

  return (
    <div>
      <Accordion expanded={expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={() => (!alwaysOpen ? setExpanded(!expanded) : null)}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            {icon}
            <Typography variant="h6" component="span">
              {header}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
}
